import { render, staticRenderFns } from "./PauseSVG.vue?vue&type=template&id=4b3ffd4f&scoped=true&"
import script from "./PauseSVG.vue?vue&type=script&lang=js&"
export * from "./PauseSVG.vue?vue&type=script&lang=js&"
import style0 from "./PauseSVG.vue?vue&type=style&index=0&id=4b3ffd4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ffd4f",
  null
  
)

export default component.exports